import { Collection } from 'modules/core/lib/mobx-rest'

import LeaveHistory from 'modules/timeoff/store/models/LeaveHistory'

class LeaveHistories extends Collection<LeaveHistory> {
  get cacheKey(): string {
    return 'leaveHistories'
  }

  get indexes() {
    return ['leave_id']
  }

  model() {
    return LeaveHistory
  }
}

export default new LeaveHistories()
